import { EnvironmentWarningForStage } from "@components/alert_banner/EnvironmentWarningForStage";
import type { GetStaticPropsContext } from "next";
import Head from "next/head";
import { Turnstile } from "@components/request-access/Turnstile";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

export default function RequestAccessPage() {
  const { t } = useTranslation(["request_access", "common"]);

  return (
    <>
      <Head>
        <title>{`myCargill - ${t("common:header.get_access")}`}</title>
        <meta
          name="description"
          content={t("common:header.get_access") || undefined}
        />
      </Head>
      <EnvironmentWarningForStage />
      <Turnstile />
    </>
  );
}

export async function getStaticProps(context: GetStaticPropsContext) {
  return {
    props: {
      ...(await serverSideTranslations(context.locale as string, [
        "common",
        "request_access",
      ])),
    },
  };
}
